import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import bookmarkValidations from '../validators/bookmark';

export default class BookmarksController extends Controller {
  @service('beta-toggle') betaService;
  @service('organisation') organisationService;
  @service currentUser;
  @service store;

  bookmarkValidations = bookmarkValidations;

  @tracked showModal = false;

  @tracked bookmark_form = null;
  @tracked isEdit = false;

  get bookmarks() {
    return this.store
      .peekAll('bookmark')
      .slice()
      .filter(
        (item) =>
          !item.belongsTo('team').id() && !item.belongsTo('initiative').id(),
      );
  }

  @action
  showBookmarkModal() {
    this.showModal = true;
    this.bookmark_form = this.store.createRecord('bookmark');
  }

  @action
  hideModal() {
    this.showModal = false;
    if (!this.bookmark_form?.id) this.bookmark_form?.deleteRecord?.();
    this.bookmark_form = null;
    this.isEdit = false;
  }

  @action
  async addBookmark(changeset) {
    if (changeset.title?.length <= 0) return;
    if (changeset.icon?.length <= 0) return;
    if (changeset.url?.length <= 0) return;
    try {
      this.bookmark_form.title = changeset.title;
      this.bookmark_form.icon = changeset.icon;
      this.bookmark_form.url = changeset.url;
      this.bookmark_form.organisation = this.organisationService.organisation;
      await this.bookmark_form.save();
      this.hideModal(false);
      changeset.rollback();
    } catch (err) {
      console.log(err);
    }
    // console.log(changeset.error);
  }

  @action
  editBookmark(bookmark) {
    this.bookmark_form = bookmark;
    this.showModal = true;
    this.isEdit = true;
  }
}
